module.exports = __webpack_public_path__ + "img/9788946065956.2202b513.jpg";